export default __webpack_public_path__ + "static/media/image-11.6ad75e13.gif";